import { inject, Injectable } from "@angular/core";
import { ExperienceLink, ExperienceModel } from "src/app/models/experience-link";
import { ExperienceType } from "src/app/models/experiences";
import { LocaleService } from "src/app/services/locale.service";

@Injectable({
  providedIn: 'root'
})
export class BookclubLinksDialogFactory {

  private readonly localeService = inject(LocaleService);

  buildLinks(links: ExperienceLink[]): ExperienceModel[] {
    const moderateLinks: ExperienceModel = {
      label: this.localeService.instant('bookClubs.carousel.moderates.default'),
      type: ExperienceType.MODERATES,
      experienceLinks: links.filter((link) => link.type === ExperienceType.MODERATES),
    };
    const followingLinks: ExperienceModel = {
      label: this.localeService.instant('bookClubs.carousel.followed.default'),
      type: ExperienceType.FOLLOWING,
      experienceLinks: links.filter((link) => link.type === ExperienceType.FOLLOWING),
    };
    const plainLinks: ExperienceModel = {
      label: this.localeService.instant('bookClubs.carousel.without.enrichment'),
      type: ExperienceType.PLAIN,
      experienceLinks: links.filter((link) => link.type === ExperienceType.PLAIN),
    };
    return [moderateLinks, followingLinks, plainLinks];
  }
}